import * as axios from 'axios'

class BisnodeService {
  async search (name) {
    const response = await axios.post('/api/bisnode/search/v0/name', { 'request': name })
    return response.data.response
  }
}

export default new BisnodeService()
